import { C } from '../../lib/tokens.js';
import { t } from '../../lib/data.js';
import { PageShell } from '../../components/layout/PageShell.jsx';

// A card of the About grid: icon + small caps title, same look as the board lanes / type cards.
function InfoCard({ icon, title, children }) {
  return (
    <div style={{ background: C.tin, border: `1px solid ${C.mercury}`, borderRadius: 6, padding: 20, display: 'flex', flexDirection: 'column', gap: 14, minWidth: 0 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <span style={{ width: 36, height: 36, borderRadius: '50%', background: C.rowActive, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flex: 'none' }}>
          <span className="material-icons" style={{ fontSize: 20, color: C.liquid }}>{icon}</span>
        </span>
        <span style={{ fontSize: 11, fontWeight: 500, color: C.iron, textTransform: 'uppercase', letterSpacing: '0.06em' }}>{title}</span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>{children}</div>
    </div>
  );
}

const row = { display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 };

export function AboutPage() {
  return (
    <PageShell title={t('about.title')} subtitle={t('about.intro')}>
      {/* Auto-fit grid: three columns on a wide screen, one on a phone */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 16, maxWidth: 1100 }}>

        <InfoCard icon="support_agent" title={t('about.support')}>
          <div style={row}>
            <span className="material-icons" style={{ fontSize: 18, color: C.silver }}>email</span>
            <a href={`mailto:${t('about.support.email')}`} style={{ fontSize: 14, color: C.liquid, textDecoration: 'none', overflowWrap: 'anywhere' }}>
              {t('about.support.email')}
            </a>
          </div>
          <div style={row}>
            <span className="material-icons" style={{ fontSize: 18, color: C.silver }}>phone</span>
            <span style={{ fontSize: 14, color: C.fg }}>{t('about.support.phone')}</span>
          </div>
        </InfoCard>

        <InfoCard icon="gavel" title={t('about.legal')}>
          <a href="#" style={{ ...row, fontSize: 14, color: C.liquid, textDecoration: 'none' }}>
            <span className="material-icons" style={{ fontSize: 16 }}>open_in_new</span>
            {t('about.legal.privacy')}
          </a>
        </InfoCard>

        <InfoCard icon="monitor_heart" title={t('about.status')}>
          <div style={row}>
            <span style={{ width: 10, height: 10, borderRadius: '50%', background: C.patina, flex: 'none' }} />
            <span style={{ fontSize: 14, color: C.fg }}>{t('about.status.operational')}</span>
          </div>
        </InfoCard>

      </div>
    </PageShell>
  );
}
